export default {
  email_confirm: {
    header: {
      title: '电子邮件地址已确认',
    },
    completed: {
      // section_one: '',
      // section_two: '',
      // section_three: '',
      // section_four: '',
    },
    expired: {
      // section_one: '',
      // section_two: '',
      // section_three: '',
    },
    btn: {
      // service_top: '',
      // login: '',
      register: '注册',
      rating_url: 'https://asuene.com/rating/en',
    },
  },
}
